export default "__VITE_ASSET__BmHXJELV__"